export var calcSubmitFlowTotalDuration = function (submitTracker) {
    var timePoint_user_submit_start = submitTracker.getTimePoint('user_submit_start');
    var timePoint_plan_computed_end = submitTracker.getTimePoint('plan_computed_end');
    if (!timePoint_user_submit_start || !timePoint_plan_computed_end) {
        return 0;
    }
    return Math.floor(performance.now() - submitTracker.getStartTimestamp() - (timePoint_user_submit_start - timePoint_plan_computed_end));
};
export var calcPlanModalStayDuration = function (submitTracker) {
    var timePoint_user_submit_start = submitTracker.getTimePoint('user_submit_start');
    var timePoint_plan_computed_end = submitTracker.getTimePoint('plan_computed_end');
    if (!timePoint_user_submit_start || !timePoint_plan_computed_end) {
        return 0;
    }
    return Math.floor(timePoint_user_submit_start - timePoint_plan_computed_end);
};
export var calcClickSubmitToFinishDuration = function (submitTracker) {
    var timePoint_user_submit_start = submitTracker.getTimePoint('user_submit_start');
    if (!timePoint_user_submit_start) {
        return 0;
    }
    return Math.floor(performance.now() - timePoint_user_submit_start);
};
export var validInteractionFilterForBill = function (target) {
    var billEditableContainer = document.querySelector('#bill-info-editable-container');
    var billReadOnlyContainer = document.querySelector('#bill-info-readonly-container');
    var feeContainer = document.querySelector('#FeeDetailView');
    var billInfoPartCustomFooter = document.querySelector('#billInfoPart-custom-footer');
    var billInfoPartFooter = document.querySelector('#billInfoPart-footer');
    return [billEditableContainer, billReadOnlyContainer, feeContainer, billInfoPartCustomFooter, billInfoPartFooter].some(function (container) { return container === null || container === void 0 ? void 0 : container.contains(target); });
};
export var validInteractionFilterForFee = function (target) {
    var feeContainer = document.querySelector('#FeeDetailView');
    return feeContainer === null || feeContainer === void 0 ? void 0 : feeContainer.contains(target);
};
